import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import deDETranslation from "./locales/de-DE/translation.json";
import enTranslation from "./locales/en/translation.json";
import enAUTranslation from "./locales/en-AU/translation.json";
import enCATranslation from "./locales/en-CA/translation.json";
import enGBTranslation from "./locales/en-GB/translation.json";
import esTranslation from "./locales/es/translation.json";
import esESTranslation from "./locales/es-ES/translation.json";
import fiFITranslation from "./locales/fi-FI/translation.json";
import frCATranslation from "./locales/fr-CA/translation.json";
import frFRTranslation from "./locales/fr-FR/translation.json";
import isISTranslation from "./locales/is-IS/translation.json";
import itITTranslation from "./locales/it-IT/translation.json";
import jaJPTranslation from "./locales/ja-JP/translation.json";
import nbNOTranslation from "./locales/nb-NO/translation.json";
import plPLTranslation from "./locales/pl-PL/translation.json";
import ptBRTranslation from "./locales/pt-BR/translation.json";
import ptPTTranslation from "./locales/pt-PT/translation.json";
import thTHTranslation from "./locales/th-TH/translation.json";
import zhSGTranslation from "./locales/zh-SG/translation.json";
import zhTWTranslation from "./locales/zh-TW/translation.json";

// Keys are lower-cased because of `lowerCaseLng` below.
//
// Every locale here is delivered by the Procore localization pipeline except
// `fi-fi`. Procore's own @procore/core-react ships no Finnish and the pipeline
// does not manage it, so src/locales/fi-FI is MAINTAINED BY HAND until the i18n
// team onboards Finnish. Do not let a translation sync overwrite or prune it.
const resources = {
    en: { translation: enTranslation },
    "en-au": { translation: enAUTranslation },
    "en-ca": { translation: enCATranslation },
    "en-gb": { translation: enGBTranslation },
    "de-de": { translation: deDETranslation },
    es: { translation: esTranslation },
    "es-es": { translation: esESTranslation },
    "fi-fi": { translation: fiFITranslation },
    "fr-ca": { translation: frCATranslation },
    "fr-fr": { translation: frFRTranslation },
    "is-is": { translation: isISTranslation },
    "it-it": { translation: itITTranslation },
    "ja-jp": { translation: jaJPTranslation },
    "nb-no": { translation: nbNOTranslation },
    "pl-pl": { translation: plPLTranslation },
    "pt-br": { translation: ptBRTranslation },
    "pt-pt": { translation: ptPTTranslation },
    "th-th": { translation: thTHTranslation },
    "zh-sg": { translation: zhSGTranslation },
    "zh-tw": { translation: zhTWTranslation },
};

// The bare codes are no longer shipped as their own files — the pipeline's
// regional locales supersede them. They stay mapped here so existing links,
// stored preferences and browser-detected languages keep resolving to a real
// translation instead of dropping to English. `no` is the legacy macrolanguage
// code for Norwegian and `nb` its modern equivalent; both point at nb-NO.
const fallbackLng = {
    de: ["de-DE", "en"],
    fr: ["fr-FR", "en"],
    no: ["nb-NO", "en"],
    nb: ["nb-NO", "en"],
    fi: ["fi-FI", "en"],
    default: ["en"],
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        debug: import.meta.env.MODE !== "production",
        fallbackLng,
        supportedLngs: Object.keys(resources),
        // Do not add `nonExplicitSupportedLngs` here. It makes isSupportedCode
        // test only the base language part, and since supportedLngs holds
        // regional codes exclusively, every one of them stops matching and the
        // whole app falls back to English.
        lowerCaseLng: true,
        interpolation: {
            escapeValue: false,
        },
    });
export default i18n;
